import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, Fragment as _Fragment, mergeProps as _mergeProps, renderList as _renderList } from "vue";
const _hoisted_1 = {
  class: "separate-account-rule"
};
const _hoisted_2 = {
  class: "toolbox"
};
const _hoisted_3 = {
  class: "wrapper"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "团队名称", -1);

const _hoisted_5 = {
  class: "wrapper"
};

const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "分账状态", -1);

const _hoisted_7 = {
  class: "wrapper"
};

const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "自动结算配置", -1);

const _hoisted_9 = {
  class: "wrapper"
};

const _hoisted_10 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_11 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_12 = {
  class: "table-toolbox"
};

const _hoisted_13 = /*#__PURE__*/_createTextVNode("新增");

const _hoisted_14 = {
  key: 0,
  style: {
    "color": "green"
  }
};
const _hoisted_15 = {
  key: 1,
  style: {
    "color": "red"
  }
};

const _hoisted_16 = /*#__PURE__*/_createTextVNode("规则");

const _hoisted_17 = /*#__PURE__*/_createTextVNode("账号/费率");

const _hoisted_18 = /*#__PURE__*/_createTextVNode("自动结算");

const _hoisted_19 = /*#__PURE__*/_createTextVNode("开通自动结算功能");

const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "每笔订单分账总额", -1);

const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "%", -1);

const _hoisted_22 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_23 = /*#__PURE__*/_createTextVNode("确定");

const _hoisted_24 = {
  class: "supplier-name",
  style: {
    "font-size": "16px",
    "font-weight": "bold",
    "margin-bottom": "10px"
  }
};

const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-left": "10px"
  }
}, "%", -1);

const _hoisted_26 = /*#__PURE__*/_createTextVNode("取消");

import { ref, onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { getVexTableProps } from '@/config';
import Axios from '@/request/createAxiosInstalce';
import { savePlatformServiceFee, getDistributorList } from '@/request';
import { ElMessageBox, ElMessage } from 'element-plus';
import AutoSettleModal from './components/auto-settle-modal.vue';
export default {
  name: 'index',

  setup(__props) {
    const router = useRouter();
    onMounted(() => {
      getRuleValue();
      getBranchList();
    });
    const storeVuex = useStore();
    const userType = computed(() => storeVuex.state.user.userType);
    const search = ref({
      supplierName: '',
      splitStatus: '',
      autoSettlement: ''
    });
    const table = ref();
    const tableOptions = getVexTableProps({
      columns: [{
        title: '团队名称',
        field: 'supplierName'
      }, {
        title: '团队负责人',
        field: 'supplierLeaderName'
      }, {
        title: '分账状态',
        field: 'splitStatus',
        slots: {
          default: 'splitStatus'
        }
      }, {
        title: '最近更新人',
        field: 'updateBy'
      }, {
        title: '更新时间',
        field: 'updateTime'
      }, {
        title: '自动结算配置',
        field: 'autoSettlement',
        slots: {
          default: 'autoSettlement'
        }
      }, {
        title: '自动结算费率',
        field: 'serviceFeeRate',
        slots: {
          default: 'serviceFeeRate'
        }
      }, {
        title: '操作',
        field: 'operation',
        width: '260px',
        slots: {
          default: 'operation'
        }
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(resolve => {
            let params = _objectSpread({
              page: page.currentPage,
              pageSize: page.pageSize
            }, search.value);

            Axios.get('/admin/split/rule/getSupplierSplitList.json', {
              params
            }).then(res => {
              if (!res.data.success) return;
              resolve({
                total: res.data.data.total,
                result: res.data.data.list
              });
            });
          })
        }
      }
    });

    function splitStatusChange(v, data) {
      let url = `/admin/split/rule/updateSupplierSplitStatus.json?splitStatus=${v}&supplierId=${data.supplierId}`;
      Axios.post(url).then(res => {
        let {
          success,
          msg
        } = res.data;

        if (success) {
          ElMessage.success('操作成功');
        } else {
          ElMessage.error(msg);
          data.splitStatus = 0;
        }
      });
    }

    function reset() {
      search.value = {
        supplierName: '',
        splitStatus: ''
      };
      table.value.commitProxy('reload');
    } // 平台服务费费率


    const ruleModal = ref({
      show: false,
      data: undefined,
      value: undefined
    });

    function getRuleValue() {
      Axios.get('/admin/split/rule/getPlatformServiceFee.json').then(res => {
        let {
          success,
          data
        } = res.data;

        if (success) {
          let value = (parseFloat(data.dictitemCode) * 100).toFixed(2);
          ruleModal.value.value = value;
          ruleModal.value.data = value;
        }
      });
    }

    function editRuleHandle() {
      ruleModal.value.show = true; // getRuleValue()
    }

    function editRuleConfirm() {
      let value = ruleModal.value.value;

      if (!value) {// ElMessage.error('请填写费率')
        // return
      }

      let body = {
        platformServiceFee: value / 100
      };
      savePlatformServiceFee(body).then(res => {
        let {
          success,
          msg
        } = res;

        if (success) {
          ElMessage.success('操作成功');
          ruleModal.value.show = false;
          getRuleValue();
        } else {
          ElMessage.error(msg);
        }
      });
    } // 自动结算


    const settleModal = ref({
      show: false
    });

    function autoSettleHandle(row) {
      let params = {
        supplierId: row.supplierId
      };
      Axios.get('/admin/split/rule/checkCncpAccount.json', {
        params
      }).then(res => {
        let {
          checkResult
        } = res.data.data;

        if (checkResult) {
          router.push({
            name: 'sepaccountAutoSetting',
            query: {
              supplierId: row.supplierId,
              supplierName: row.supplierName
            }
          });
          return;
        }

        ElMessageBox.confirm('您分账规则中包含团队主体角色分账，请先申请团队主体分账账号后进入自动分账设置。', '提示', {
          confirmButtonText: '继续设置',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // settleModal.value.show = true
          router.push({
            name: 'sepaccountAutoSetting',
            query: {
              supplierId: row.supplierId,
              supplierName: row.supplierName
            }
          });
        }).catch(e => {});
      });
    } // 账号费率


    const accountRateModal = ref({
      show: false,
      value: undefined,
      cncpAccountId: '',
      supplierId: '',
      supplierName: '',
      type: 'edit'
    });

    function accountRateHandle(row, type) {
      accountRateModal.value = {
        show: true,
        supplierId: row.supplierId,
        supplierName: row.supplierName,
        cncpAccountId: '',
        value: undefined,
        type,
        autoSettlement: row.autoSettlement
      };
      if (type === 'create') return;
      let params = {
        supplierId: row.supplierId
      };
      Axios.get('/admin/split/rule/getSupplierServiceFee.json', {
        params
      }).then(res => {
        let {
          success,
          data
        } = res.data;

        if (success) {
          if (data.serviceFee) {
            accountRateModal.value.value = (parseFloat(data.serviceFee) * 100).toFixed(2);
          } else {
            accountRateModal.value.value = ruleModal.value.data;
          }

          accountRateModal.value.cncpAccountId = data.cncpAccountId;
        }
      });
    }

    function accountRateSubmit() {
      let {
        value,
        type,
        autoSettlement
      } = accountRateModal.value;

      if (type === 'edit' && autoSettlement == 1) {
        ElMessage.error('编辑内容会影响该团队自动结算规则，请联系团队关闭其自动结算开关后编辑');
        return;
      }

      if (!accountRateModal.value.cncpAccountId) {
        ElMessage.error('请选择账号');
        return;
      }

      if (!value) {// ElMessage.error('请填写费率')
        // return
      }

      let body = {
        supplierId: accountRateModal.value.supplierId,
        serviceFee: value / 100,
        cncpAccountId: accountRateModal.value.cncpAccountId
      };
      Axios.post('/admin/split/rule/updateSupplierServiceFee.json', body).then(res => {
        let {
          success,
          msg
        } = res.data;

        if (success) {
          ElMessage.success('操作成功');
          table.value.commitProxy('reload');
          accountRateModal.value.show = false;
        } else {
          ElMessage.error(msg);
        }
      });
    }

    const branchList = ref([]);

    function getBranchList() {
      let params = {
        supplierCategory: 2,
        paymentFlowStatus: 40,
        page: 1,
        rows: 1000
      };
      getDistributorList(params).then(res => {
        branchList.value = res.rows || [];
      });
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_switch = _resolveComponent("el-switch");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_input_number = _resolveComponent("el-input-number");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_form = _resolveComponent("el-form");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_el_input, {
        modelValue: search.value.supplierName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => search.value.supplierName = $event),
        placeholder: "请输入团队名称"
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createVNode(_component_el_select, {
        modelValue: search.value.splitStatus,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => search.value.splitStatus = $event),
        placeholder: "请选择分账状态"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: "全部",
          value: ""
        }), _createVNode(_component_el_option, {
          label: "开启",
          value: "1"
        }), _createVNode(_component_el_option, {
          label: "关闭",
          value: "0"
        })]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createVNode(_component_el_select, {
        modelValue: search.value.autoSettlement,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => search.value.autoSettlement = $event),
        placeholder: "请选择"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: "全部",
          value: ""
        }), _createVNode(_component_el_option, {
          label: "开启",
          value: "1"
        }), _createVNode(_component_el_option, {
          label: "关闭",
          value: "0"
        })]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[3] || (_cache[3] = $event => table.value.commitProxy('reload'))
      }, {
        default: _withCtx(() => [_hoisted_10]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: reset
      }, {
        default: _withCtx(() => [_hoisted_11]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[4] || (_cache[4] = $event => _unref(router).push({
          name: 'sepaccountRuleSetting'
        }))
      }, {
        default: _withCtx(() => [_hoisted_13]),
        _: 1
      })]), _createVNode(_component_vxe_grid, _mergeProps({
        ref_key: "table",
        ref: table
      }, _unref(tableOptions)), {
        splitStatus: _withCtx(({
          row
        }) => [_createVNode(_component_el_switch, {
          modelValue: row.splitStatus,
          "onUpdate:modelValue": $event => row.splitStatus = $event,
          activeValue: 1,
          inactiveValue: 0,
          onChange: v => splitStatusChange(v, row)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]),
        autoSettlement: _withCtx(({
          row
        }) => [row.autoSettlement == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_14, "开启")) : (_openBlock(), _createElementBlock("span", _hoisted_15, "关闭"))]),
        serviceFeeRate: _withCtx(({
          row
        }) => [_createElementVNode("span", null, _toDisplayString(row.serviceFeeRate * 100 + '%'), 1)]),
        operation: _withCtx(({
          row
        }) => [_createVNode(_component_el_button, {
          size: "small",
          type: "primary",
          onClick: $event => _unref(router).push({
            name: 'sepaccountRuleSetting',
            query: {
              supplierId: row.supplierId
            }
          })
        }, {
          default: _withCtx(() => [_hoisted_16]),
          _: 2
        }, 1032, ["onClick"]), row.serviceFeeRate ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_unref(userType) == 2 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          size: "small",
          type: "primary",
          onClick: $event => accountRateHandle(row, 'edit')
        }, {
          default: _withCtx(() => [_hoisted_17]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
          size: "small",
          type: "primary",
          onClick: $event => autoSettleHandle(row)
        }, {
          default: _withCtx(() => [_hoisted_18]),
          _: 2
        }, 1032, ["onClick"])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_unref(userType) == 2 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          size: "small",
          onClick: $event => accountRateHandle(row, 'create')
        }, {
          default: _withCtx(() => [_hoisted_19]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true)], 64))]),
        _: 1
      }, 16), _createVNode(_component_el_dialog, {
        modelValue: ruleModal.value.show,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ruleModal.value.show = $event),
        title: "平台服务费费率（默认值）",
        width: "500px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[6] || (_cache[6] = $event => ruleModal.value.show = false)
        }, {
          default: _withCtx(() => [_hoisted_22]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: editRuleConfirm
        }, {
          default: _withCtx(() => [_hoisted_23]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", null, [_hoisted_20, _createVNode(_component_el_input_number, {
          modelValue: ruleModal.value.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ruleModal.value.value = $event),
          min: 0,
          max: 100,
          "controls-position": "right",
          precision: 2,
          style: {
            "width": "120px",
            "margin": "0 10px"
          }
        }, null, 8, ["modelValue"]), _hoisted_21])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: accountRateModal.value.show,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => accountRateModal.value.show = $event),
        title: accountRateModal.value.type === 'create' ? '开通自动结算功能' : '账号/费率',
        width: "500px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[10] || (_cache[10] = $event => accountRateModal.value.show = false)
        }, {
          default: _withCtx(() => [_hoisted_26]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: accountRateSubmit
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(accountRateModal.value.type === 'create' ? '确定开通' : '确定'), 1)]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_24, _toDisplayString(accountRateModal.value.supplierName), 1), _createVNode(_component_el_form, {
          "label-width": "140px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "团队主体分账账号："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: accountRateModal.value.cncpAccountId,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => accountRateModal.value.cncpAccountId = $event),
              filterable: ""
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(branchList.value, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  label: item.branchName,
                  value: item.branchId,
                  key: item.branchId,
                  filterable: ""
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "平台服务费率："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: accountRateModal.value.value,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => accountRateModal.value.value = $event),
              min: 0,
              max: 100,
              "controls-position": "right",
              precision: 2,
              style: {
                "width": "120px"
              }
            }, null, 8, ["modelValue"]), _hoisted_25]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue", "title"]), _createVNode(AutoSettleModal, {
        modelValue: settleModal.value.show,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => settleModal.value.show = $event)
      }, null, 8, ["modelValue"])]);
    };
  }

};